import { validationIsEqual } from '../status';
import {
    validateDateOfBirth,
    validateEmail,
    validateName,
    validateContactNumber,
    validateSingleSelection,
    validateNumber,
    validateAlphaNumericStringAllowingOnlyNumbers,
    validateAlphaNumericString,
    validateKraPinNumber,
    validateKeCarRegNumber,
    validateNumericString,
    validateAlphaString
} from '@om/validation';
import {
    TITLE_SET_VALUE,
    FULL_NAME_SET_VALUE,
    ID_TYPE_SET_VALUE,
    DOB_SET_VALUE,
    ID_NUMBER_SET_VALUE,
    KRA_NUMBER_SET_VALUE,
    PHONE_NUMBER_SET_VALUE,
    EMAIL_SET_VALUE,
    setIdNumberValid,
    setIdTypeValid,
    setFullNameValid,
    setEmailValid,
    setPhoneNumberValid,
    setDOBValid,
    setKraNumberValid,
    setTitleValid
} from '../../../actions/travel/personalDetails';

let prevValidationAction = null;
export const travelDetailsValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case TITLE_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Title',
                });
                return setTitleValid(error);

            case FULL_NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 48,
                    subject: 'Full Name',
                });
                return setFullNameValid(error);

            case ID_TYPE_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subjet: 'ID TYPE'
                });
                return setIdTypeValid(error);

            case ID_NUMBER_SET_VALUE:
                error = validateNumericString(action.value, { min: 8, max: 15 });
                return setIdNumberValid(error);
            case KRA_NUMBER_SET_VALUE:
                error = validateKraPinNumber(action.value);
    
                return setKraNumberValid(error);

            case PHONE_NUMBER_SET_VALUE:
                error = validateContactNumber(action.value, 'Phone Number');
                return setPhoneNumberValid(error);

            case EMAIL_SET_VALUE:
                error = validateEmail(action.value, {
                    min: 6,
                    max: 200,
                    subject: 'Email address',
                    required: true,
                });
                return setEmailValid(error);

            case DOB_SET_VALUE:
                error = validateDateOfBirth(action.value, { min: 18, max: 85 });
                return setDOBValid(error);

            default:
                return null;
        }
    })();

    if (
        !validationAction ||
        validationIsEqual(validationAction, prevValidationAction)
    ) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
